import { Info } from "lucide-react";

export const InstructionsSectionHeader = (props: any) => {
    return (<div className="d-flex align-items-center">
        {window.useGaiaDesign ?
            <div><Info size={24} /></div> :
            <span className="vismaicon vismaicon-filled vismaicon-info" aria-hidden="true"></span>
        }
        <h3 className="pl-16 pr-16 mb-0">{props.altinnInstructionsTitle}</h3>
        <span className="caret"></span>
    </div>);
};
